import React from 'react';
import "./UserGuideComponent.css";
const UserGuideComponent = ({
  pdfUrl
}) => {
  return <div>
        <iframe src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`} width="100%" height="600px" className="migrated-style-userguidecomponent-b6becd-1"></iframe>
    </div>;
};
export default UserGuideComponent;
